import { linkColor, linkHoverColor } from '@clatter/ui';
import React from 'react';
import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
  }

  html {
    font-size: 14px;
    font-family: 'Maven Pro', sans-serif;
  }

  body {
    overflow-y: scroll;
    background: #F4F7FC;
    margin: 0;
    line-height: 1.4;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0 0 16px;
    padding: 0;
    font-weight: 700;
  }

  h1 {
    font-size: 36px;
  }

  h2 {
    font-size: 24px;
  }

  h3 {
    font-size: 18px;
  }

  h4 {
    font-size: 16px;
  }

  p {
    margin: 16px 0;
  }

  a {
    text-decoration: none;
    color: ${linkColor};

    &:hover {
      color: ${linkHoverColor};
    }
  }
`;

const Page = ({ children }) => (
  <>
    <GlobalStyle />
    {children}
  </>
);

export default Page;
